import { Record } from 'immutable';

export default class StaffingCompanyGroupRecord extends Record({
  id: undefined,
  availableDateSetting: undefined,
  createdAt: undefined,
  defaultResourceMileageAllowanceAmount: undefined,
  defaultSenderEmailAddress: undefined,
  emailDomain: undefined,
  enabled: undefined,
  feature: undefined,
  domains: undefined,
  holidayPayRate: undefined,
  invoiceSetting: undefined,
  links: undefined,
  logo: undefined,
  name: undefined,
  langCode: undefined,
  countryCode: undefined,
  personalDataProcessingSmsText: undefined,
  phone: undefined,
  slug: undefined,
  staffingCompanies: undefined,
  hospIvo: undefined,
  payment: undefined,
  invoice: undefined,
  import: undefined,
  sms: undefined,
  newsletter: undefined,
  booking: undefined,
  resource: undefined,
  agreement: undefined,
  inquiry: undefined,
  list: undefined,
  service: undefined,
  publicTimeReport: undefined,
  inquiryAd: undefined,
  ekopost: undefined,
  exposeCustomerFeeToCustomer: undefined,
  exposeResourceFeeToResource: undefined,
  paymentSettingSplitTimeCode: undefined,
  paymentSettingSplitHolidayPay: undefined,
  paymentSettingIncludeWorkTypeAndTimeCode: undefined,
  paymentSettingIncludeBookingNumber: undefined,
  paymentSettingIncludeSalaryType: undefined,
  paymentSettingIncludeWeekNumber: undefined,
  paymentSettingIncludeServices: undefined,
  paymentSettingIncludeCustomer: undefined,
  paymentSettingUseRounding: undefined,
  paymentSettingIncludeTimeReport: undefined,
  invoiceSettingAddWorkTypeAndTimeCodeRow: undefined,
  invoiceSettingAddServiceRow: undefined,
  invoiceSettingAddExternalOrderNumber: undefined,
  invoiceSettingAddAddressReferenceRow: undefined,
  invoiceSettingAddCustomerRow: undefined,
  invoiceSettingAddResourceRow: undefined,
  invoiceSettingGroupRowsBy: 'week',
  invoiceSettingIncludeDate: undefined,
  invoiceSettingIncludeWorkTypeAndTimeCode: undefined,
  invoiceSettingIncludeService: undefined,
  invoiceSettingIncludeResource: undefined,
  invoiceSettingUseRounding: undefined,
  invoiceSettingIncludeTime: undefined,
  invoiceSettingIncludeWeek: undefined,
  invoiceSettingIncludeTimeReports: undefined,
  invoiceSettingInvoiceReferenceType: 'booking_external_order_number',
  invoiceSettingSplitOnResource: undefined,
  fortnox: undefined,
  fortnoxInvoice: undefined,
  fortnoxSalary: undefined,
  customerBookingConfirmationIncludeBookingNumber: undefined,
  customerBookingConfirmationIntroText: '...',
  customerBookingConfirmationSchemaType: 'full_schema',
  resourceBookingConfirmationIncludeForSelfEmployed: undefined,
  resourceBookingConfirmationIncludeServices: undefined,
  resourceBookingConfirmationSchemaType: 'start_date',
  resourceBookingConfirmationIntroText: '...',
  resourceBookingConfirmationIncludeCustomerName: undefined,
  resourceBookingConfirmationIncludeStaffingCompanyOrganisationNumber: undefined,
  resourceBookingConfirmationIncludeResourceOrganisationNumber: undefined,
  resourceBookingConfirmationIncludeResourceIdentityNumber: undefined,
  paxml: undefined,
  timereportAttestByCustomer: undefined,
  recruitment: undefined,
  hidePhoneNumberInRecruitmentAd: undefined,
  oneflow: undefined,
  bjornLunden: undefined,
  bjornLundenInvoice: undefined,
  bjornLundenSalary: undefined,
  bjornLundenSync: undefined,
  questionnaireCompletedText: undefined,
  resourceBookingConfirmationServiceTitle: undefined,
  resourceBookingConfirmationCustomCellHeader: undefined,
  resourceBookingConfirmationCustomCellContent: undefined,
  customerBookingConfirmationCustomCellHeader: undefined,
  customerBookingConfirmationCustomCellContent: undefined,
  customerBookingConfirmationIncludeResourceContactDetails: undefined,
  customerBookingConfirmationIncludeResourcePersonalNumber: undefined,
  customerBookingConfirmationIncludePaymentTerms: undefined,
  hogia: undefined,
}) {
}
